import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import SkipPreviousIcon from '@mui/icons-material/SkipPrevious';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import SkipNextIcon from '@mui/icons-material/SkipNext';

const namePromptMapping = {
    "":""
}

export default function MediaControlCard({image, name, onClick, prompt}) {
  const theme = useTheme();

  return (
    <Card sx={{ display: 'flex' }} onClick={()=>onClick(prompt, true)}>
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <CardContent sx={{ flex: '1 0 auto' }}>
          <Typography component="div" variant="h5" sx={{fontSize:"large", fontWeight:"500"}}>
            {name}
          </Typography>
        </CardContent>
      </Box>
      <CardMedia
        component="img"
        sx={{ width: 150, height:150 }}
        image={image.contentUrl}
        alt="Live from space album cover"
      />
    </Card>
  );
}
